import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";

function DocsRedirect() {
  React.useEffect(() => {
    window.location.replace("https://decentralizedexchange.gitbook.io/docs");
  }, []);
  return null;
}

function App() {
  return (
    <div className="min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/docs" element={<DocsRedirect />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#FFFFFF",
            border: "1px solid #E5E7EE",
            color: "#0F172A",
            fontFamily: "Manrope, system-ui, sans-serif",
            borderRadius: 14,
            boxShadow: "0 8px 32px -8px rgba(15, 23, 42, 0.12)",
          },
        }}
      />
    </div>
  );
}

export default App;
